<template lang="pug">
    v-form.c-form

        // Switch
        v-switch.c-switch(
            :label="$t('business.goals.consecutiveDays.switchLabel')"
            v-model="model.isActive"
            :disabled="isLoading"
            color="action"
            hide-details
        )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapFields('goals', {
                model: 'dailyActivity'
            }),
            ...mapGetters('goals', ['isLoading'])
        }
    };
</script>
